import Medusa from '@medusajs/medusa-js'

// Defaults to standard port for Medusa server
const PUBLIC_MEDUSA_BACKEND_URL = process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL || 'http://localhost:9000'
const PRIVATE_MEDUSA_BACKEND_URL = process.env.MEDUSA_BACKEND_URL || PUBLIC_MEDUSA_BACKEND_URL

const medusaClient = new Medusa({ baseUrl: PUBLIC_MEDUSA_BACKEND_URL, maxRetries: 3 })

export { PUBLIC_MEDUSA_BACKEND_URL, PRIVATE_MEDUSA_BACKEND_URL, /*queryClient,*/ medusaClient }
